import { createAction, createReducer } from '@reduxjs/toolkit';

const NEW_PARAMS = createAction('navigation/newParams');
const CLEAR_PARAMS = createAction('navigation/clearParams');

export const actions = {
  NEW_PARAMS,
  CLEAR_PARAMS,
};

function newParamsHandler(_prev, action) {
  const { payload } = action;
  return { ...payload };
}

function clearParams(_prev) {
  return {};
}

const reducer = createReducer(
  {},
  {
    [NEW_PARAMS]: newParamsHandler,
    [CLEAR_PARAMS]: clearParams,
  }
);

export default reducer;
